import {
  APIBlobResponse,
  APIResponse,
  PaginatedAPIResponse,
} from "../models/NetworkResponse";
import {
  PaymentLinkFilters,
  PaymentLinkListItem,
} from "../models/PaymentLinks/PaymentLinks";

import { downloadCSV, getAPI, postAPI } from "./Networking";
export default class PaymentLinksAPI {
  generatePaymentLink = async (
    orderId: number,
    providerId: string,
    percentage: number,
  ): Promise<APIResponse> => {
    try {
      const response = await postAPI(
        `/v5/payment-links/order-id/${orderId}/provider/${providerId}/generate`,
        { percentage },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  refreshPaymentLink = async (paymentLinkId: number): Promise<APIResponse> => {
    try {
      const response = await getAPI(
        `/v5/payment-links/id/${paymentLinkId}/refresh`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  getPaymentLinks = async (
    filters: PaymentLinkFilters,
  ): Promise<PaginatedAPIResponse<PaymentLinkListItem>> => {
    try {
      const queryParams = new URLSearchParams();

      queryParams.append("page_no", filters.page_no.toString());
      queryParams.append("limit", filters.limit.toString());

      if (filters.order_id) queryParams.append("order_id", filters.order_id);
      if (filters.status) queryParams.append("status", filters.status);
      if (filters.start_date) queryParams.append("start_date", filters.start_date);
      if (filters.end_date) queryParams.append("end_date", filters.end_date);
      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);
      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      const response = await getAPI(`/v5/payment-links?${queryParams.toString()}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  downloadPaymentLinksCSV = async (
    filters: Omit<PaymentLinkFilters, "page_no" | "limit">,
  ): Promise<APIBlobResponse> => {
    try {
      const queryParams = new URLSearchParams();

      if (filters.order_id) queryParams.append("order_id", filters.order_id);
      if (filters.status) queryParams.append("status", filters.status);
      if (filters.start_date) queryParams.append("start_date", filters.start_date);
      if (filters.end_date) queryParams.append("end_date", filters.end_date);
      if (filters.sort_by) queryParams.append("sort_by", filters.sort_by);
      if (filters.sort_type) queryParams.append("sort_type", filters.sort_type);

      const response = await downloadCSV(
        `/v5/payment-links/download?${queryParams.toString()}`,
      );
      return response;
    } catch (error) {
      throw error;
    }
  };
}
